var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const delay = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
export const fetchUserinfoWithRetry = (input, init, options = {}, attempt = 0) => __awaiter(void 0, void 0, void 0, function* () {
    const { maxRetries = 3, baseDelayMs = 500, maxDelayMs = 10000, backoffFactor = 2, } = options;
    /* Improvement for userInfo request after introduction of "Storage-Access-Headers" in Firefox 147
  
    Cookies are partitioned - meaning they are no longer shared accross all websites in your browser.
    After authentication, a userInfo request is made. This request is done to another website and
    cookies are no longer automatically available.
    The first userInfo request will therefore not have cookies, but the userinfo-endpoint should
    respond with the appropriate "Storage-Access" header.
    After this, the cookies should be available.
    A follow-up reqeust should then include the cookies and the userInfo request should succeed
  
    This function retries allows for retrying requests up to "maxRetries" and delays retry requests
    as to not overload the requested endpoint (defined with "baseDelayMs", "maxDelayMs" and a
    "backoffFactor").
    */
    const response = yield fetch(input, init);
    if (response && response.ok) {
        return response;
    }
    if (attempt >= maxRetries) {
        console.warn(`Could not reach requested URL`);
        return null;
    }
    const delayMs = Math.min(baseDelayMs * Math.pow(backoffFactor, attempt), maxDelayMs);
    console.warn(`Attempt ${attempt + 1} failed (${response.status}). Retrying in ${delayMs}ms...`);
    yield delay(delayMs);
    return fetchUserinfoWithRetry(input, init, options, attempt + 1);
});
